<template>
  <v-app>
    <v-main>
      <v-container v-if="checkingSignInState" fill-height fluid>
        <v-row align="center">
            <v-col align="center">
              <v-progress-circular
                indeterminate
                color="blue"
              ></v-progress-circular>
            </v-col>
        </v-row>
      </v-container>
      <router-view v-else/>
    </v-main>

    <v-bottom-navigation
      v-if="showMainNav"
      app
      color="blue"
      grow>
      <v-btn to="/discover" style="height: inherit;">
        <span>Discover</span>

        <v-icon>mdi-eye</v-icon>
      </v-btn>


      <v-icon>mdi-plus</v-icon>

      <v-btn to='/persons' style="height: inherit;">
        <span>Creatives</span>

        <v-icon>mdi-head-lightbulb-outline</v-icon>
      </v-btn>
    </v-bottom-navigation>


    <div
      v-if="showMainNav"
      class="container d-flex flex-row justify-center">
      <v-btn fab dark large color="blue" absolute style="position:fixed; bottom:0; overflow-y:scroll;" to="/add">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </div>
  </v-app>
</template>

<script>
const firebaseApp = require('firebase/app');
import firebase from "firebase";
var moment = require('moment');
var unsubPersons;
var unsubFeed;

export default {
  name: 'app',
  components: {
  },
  data() {
    return {
      showMainNav: false,
      signedInByFirebase: undefined,
      checkingSignInState:true,
      highestPriorityOfFeedImages: 1.0,
      appStore: this.$root.$data.appStore,
      images: this.$root.$data.appStore.state.images,
      appState: this.$root.$data.appStore.state,
      auth: this.$root.$data.auth,
      db: this.$root.$data.db,
      analytics: this.$root.$data.analytics,
      loggedVisit: false,
    }
  },
  computed: {
    personsQuery: function () {
      return this.appState.user.uid && this.db.collection('person').where('owner', '==', this.appState.user.uid).orderBy('created', 'desc');
    },
    imagesQuery: function () {
      return this.appState.user.uid && this.db.collection('image').where('owner', '==', this.appState.user.uid).orderBy('priority', 'desc').startAfter(this.highestPriorityOfFeedImages).limit(15);
    },
    userSignedIn: function () {
      return this.signedInByFirebase && this.appState.user.uid !== undefined;
    }
  },
  methods: {
    hideNavOnDetailScreens() {
      if (this.userSignedIn && (this.$route.path === "/persons" || this.$route.path === "/discover")) {
        this.showMainNav = true;
      } else  {
        this.showMainNav = false;
      }
    },
    ensureUserOnPublicsite() {
      if(this.$route.path !== '/'
          && this.$route.name !== 'signin'
          && this.$route.name !== 'person'
          && this.$route.name !== 'image'
          && this.$route.name !== 'legal'
          && this.$route.name !== 'privacy') {
        this.$router.push('/signin');
      }
    },
    unsubscribeListeners() {
      if(unsubPersons) {
        unsubPersons();
        unsubPersons = undefined;
      }
      if(unsubFeed) {
        unsubFeed();
        unsubFeed = undefined;
      }
    },
    async updateUserAuth(user) {
      this.signedInByFirebase = !!user;

      if(!this.signedInByFirebase) {
        this.ensureUserOnPublicsite();
        this.unsubscribeListeners();
      } else {
        if (await this.updateUserEntry(user.uid)) {
          let readPersonsFunc = this.readPersons;
          let readFeedFunc = this.readFeed;
          unsubPersons = !unsubPersons && this.personsQuery.onSnapshot(function() {
           readPersonsFunc();
          });
          let isFeedReadInProgress = false;
          unsubFeed = !unsubFeed && this.imagesQuery.onSnapshot(async function() {
            if(!isFeedReadInProgress) {
              isFeedReadInProgress = true;
              await readFeedFunc();
              isFeedReadInProgress = false;
            }
          });
        } else {
          // TODO show error
        }
      }
      this.hideNavOnDetailScreens();
      this.checkingSignInState = false;

      this.logVisit();
    },
    async checkSignedIn() {
      await this.auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
      this.auth.onAuthStateChanged(this.updateUserAuth);
    },
    async updateUserEntry(uid) {
      if(!uid) {
        console.warn(`Tried to update user entry but uid is invalid!`);
        return;
      }
      try {
        let userDoc = await this.db.collection('user').doc(uid).get();
        if (!userDoc.exists) {
          await this.db.collection('user').doc(uid).set({
            created: firebaseApp.firestore.FieldValue.serverTimestamp(),
            numImages: 0,
            numPersons: 0,
            numWebsites: 0,
            lastLogIn: firebaseApp.firestore.FieldValue.serverTimestamp(),
            numLogIns: 1,
            lastInvalidatedTopPicks: firebaseApp.firestore.FieldValue.serverTimestamp(),
          });
          this.appStore.overrideUser({
            uid: uid,
            lastInvalidatedTopPicks: moment().startOf('day'),
          });
        } else {
          let updatedUser = {
            lastLogIn: firebaseApp.firestore.FieldValue.serverTimestamp(),
            numLogIns: firebaseApp.firestore.FieldValue.increment(1),
          };
          if(!userDoc.data().lastInvalidatedTopPicks) {
            // Set the initial lastInvalidatedTopPicks
            updatedUser.lastInvalidatedTopPicks = firebaseApp.firestore.FieldValue.serverTimestamp();
          }
          await this.db.collection('user').doc(uid).update(updatedUser);

          let lastInvalidatedTopPicks = userDoc.data().lastInvalidatedTopPicks
            ? moment(userDoc.data().lastInvalidatedTopPicks.toDate()).startOf('day')
            : moment().startOf('day');
          this.appStore.overrideUser({
            uid: uid,
            lastInvalidatedTopPicks: lastInvalidatedTopPicks,
          });
        }
      } catch (error) {
        console.warn(`Could not update user data entry: ${error}`);
        return false;
      }
      return true;
    },
    readPersons() {
      let persons = [];

      this.personsQuery
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            persons.push({
              id: doc.id,
              name: doc.data().name,
              type: doc.data().type,
              owner: doc.data().owner,
            });
            // console.log(doc.id, " => ", doc.data());
          });
          this.appStore.overridePersons(persons);
          /*this.analytics.logEvent('content_loaded', {
            content_type: 'person',
            content_num: persons.length,
            value: persons.length,
          });*/
        })
        .catch((error) => {
          console.log("Error getting persons: ", error);
        });
    },
    async readFeed() {
      async function readTopPicks(that) {
        let images = [];
        let querySnapshot;
        try {
          querySnapshot= await that.imagesQuery.get();
        } catch (error) {
          console.log("Error getting images: ", error);
          return images;
        }
        querySnapshot.forEach((doc) => {
          images.push({
            id: doc.id,
            personId: doc.data().personId,
            url: doc.data().url,
            websiteUrl: doc.data().websiteUrl,
            favouritedAt: doc.data().favouritedAt,
            priority: doc.data().priority,
          });
        });
        return images;
      }

      let images = await readTopPicks(this);
      if(images.length === 0) {
        // The user did not set up any images/persons yet.
        // Keep the lastInvalidatedTopPicks up to date.
        await this.db.collection('user').doc(this.appState.user.uid).update({
          lastInvalidatedTopPicks: firebaseApp.firestore.FieldValue.serverTimestamp(),
        });
        return;
      }

      // First, check if we need to invalidate the top picks
      let today = moment().startOf('day');
      if(this.appState.user.lastInvalidatedTopPicks.isBefore(today)) {
        try {
          // Decrease the priority of the top picks
          let decrementPromises = images.map((i) =>
            this.db.collection('image').doc(i.id).update({
              priority: firebaseApp.firestore.FieldValue.increment(-1),
            })
          );
          for (let i = 0; i < decrementPromises.length; i++) {
            await decrementPromises;
          }

          // Update that we invalidated the top picks now
          await this.db.collection('user').doc(this.appState.user.uid).update({
            lastInvalidatedTopPicks: firebaseApp.firestore.FieldValue.serverTimestamp(),
          });
          this.appStore.overrideLastInavlidatedTopPicks(moment().startOf('day'));
          this.highestPriorityOfFeedImages = images[images.length - 1].priority;

          // Read the new top picks, based on the new strating priority highestPriorityOfFeedImages
          images = await readTopPicks(this);
        } catch (error) {
          console.log("Error updating lastInvalidatedTopPicks: ", error);
        }
      }

      this.appStore.overrideImages(images);
      /*this.analytics.logEvent('content_loaded', {
        content_type: 'image',
        content_num: images.length,
        value: images.length,
      });*/
    },
    async logVisit() {
      if (this.loggedVisit) return;

      this.loggedVisit = true;
      let unknownVisit, knownVisit;
      if (this.userSignedIn) {
        unknownVisit = 0;
        knownVisit = 1;
      } else {
        unknownVisit = 1;
        knownVisit = 0;
      }

      try {
        let todayAsDocId = moment().format('YYYY-MM-DD');
        let todayAnalyticsDoc = await this.db.collection('analytics').doc(todayAsDocId).get();
        if (!todayAnalyticsDoc.exists) {
          await this.db.collection('analytics').doc(todayAsDocId).set({
            pageVisits: {
              signedIn: knownVisit,
              unknown: unknownVisit,
            },
          });
          return;
        }
        await this.db.collection('analytics').doc(todayAsDocId).update({
          'pageVisits.signedIn': firebaseApp.firestore.FieldValue.increment(knownVisit),
          'pageVisits.unknown': firebaseApp.firestore.FieldValue.increment(unknownVisit),
        });
      } catch (error) {
        console.log(`Logging visit failed: ${error}`);
      }
    }
  },
  mounted() {
    this.checkSignedIn();
  },
  watch: {
     $route: function() {
       if (!this.userSignedIn) this.ensureUserOnPublicsite();
       this.hideNavOnDetailScreens();
    }
  },
  beforeDestroy: function () {
    this.unsubscribeListeners();
  },
}
</script>

<style>
.v-overlay__content {
  overflow: scroll;
  width: 100%;
  height: 100%;
}
</style>
